import React from "react";

import CircularProgress, {
    CircularProgressProps,
} from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import { Backdrop, } from "@mui/material";

interface LoadingOverlayProps {
    loading: boolean;
    message?: number;
}


function CircularProgressWithLabel(
    props: CircularProgressProps & { value: number },
) {
    return (
        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
            <CircularProgress variant="determinate" {...props} />
            <Box
                sx={{
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Typography
                    variant="caption"
                    component="div"
                    sx={{ color: 'text.secondary' }}
                >{`${Math.round(props.value)}%`}</Typography>
            </Box>
        </Box>
    );
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ loading, message }) => {
    return (
        <Backdrop open={loading} sx={{ color: "#000", zIndex: (theme) => theme.zIndex.drawer + 1 }}>
            <CircularProgressWithLabel value={message || 0} />
        </Backdrop>
    );
};

export default LoadingOverlay;
